import React from 'react';
import isEmpty from 'lodash/isEmpty';
import RouteOverviewTreeRootItem from '@Pages/RetroSynthesis/RouteTree/components/renderers/RouteOverviewTreeRootItem';
import RouteOverviewTreeItem from '@Pages/RetroSynthesis/RouteTree/components/renderers/RouteOverviewTreeItem';
import RouteOverviewTruncationItem from '@Pages/RetroSynthesis/RouteTree/components/renderers/RouteOverviewTruncationItem';

// eslint-disable-next-line import/prefer-default-export
export const renderCustomNodeElement = ({ nodeDatum = {}, ...rest }, additionalProps = {}) => {
  const isRootNode = !nodeDatum.parentId;
  const isEndNode = isEmpty(nodeDatum.children);
  if (isRootNode) {
    return <RouteOverviewTreeRootItem nodeDatum={nodeDatum} {...rest} {...additionalProps} />;
  }
  if (nodeDatum.isTruncationNode) {
    return <RouteOverviewTruncationItem nodeDatum={nodeDatum} {...rest} {...additionalProps} />;
  }
  const nodeClassName = isEndNode ? 'node__leaf' : 'node__branch';
  return <RouteOverviewTreeItem classNames={nodeClassName} nodeDatum={nodeDatum} {...rest} {...additionalProps} />;
};
